export default __webpack_public_path__ + "assets/images/smart_white.png";